const ONE_MINUTE = 60 * 1000;
const ONE_HOUR = 60 * ONE_MINUTE;
const ONE_DAY = 24 * ONE_HOUR;
const ONE_MONTH = 30 * ONE_DAY;
const ONE_YEAR = 365 * ONE_DAY;

export const formatDateKey = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatRelativeTime = (isoString) => {
    if (!isoString) {
        return null;
    }

    const parsed = new Date(isoString);
    if (Number.isNaN(parsed.getTime())) {
        return null;
    }

    const now = Date.now();
    const diff = now - parsed.getTime();

    if (diff < 0) {
        return 'gerade eben';
    }

    if (diff < ONE_MINUTE) {
        return 'gerade eben';
    }

    if (diff < ONE_HOUR) {
        const minutes = Math.floor(diff / ONE_MINUTE);
        return `vor ${minutes} ${minutes === 1 ? 'Minute' : 'Minuten'}`;
    }

    if (diff < ONE_DAY) {
        const hours = Math.floor(diff / ONE_HOUR);
        return `vor ${hours} ${hours === 1 ? 'Stunde' : 'Stunden'}`;
    }

    if (diff < ONE_MONTH) {
        const days = Math.floor(diff / ONE_DAY);
        return `vor ${days} ${days === 1 ? 'Tag' : 'Tagen'}`;
    }

    if (diff < ONE_YEAR) {
        const months = Math.floor(diff / ONE_MONTH);
        return `vor ${months} ${months === 1 ? 'Monat' : 'Monaten'}`;
    }

    const years = Math.floor(diff / ONE_YEAR);
    return `vor ${years} ${years === 1 ? 'Jahr' : 'Jahren'}`;
};
